import { render } from "./LandingPageCardPrecos.vue?vue&type=template&id=6f46342c&scoped=true"
import script from "./LandingPageCardPrecos.vue?vue&type=script&lang=js"
export * from "./LandingPageCardPrecos.vue?vue&type=script&lang=js"

import "./LandingPageCardPrecos.vue?vue&type=style&index=0&id=6f46342c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f46342c"]])

export default __exports__